<template>
  <b-form>
    <!-- this question will be updated with additional conditions (notification.statusId > 2 && notification.activeDate < ??) -->
    <ValidationProvider
      v-if="false && roadDetails && (requirements.roadPWL1Exists || requirements.roadPWL2Exists)"
      name="Alteration Area"
      rules="required|numeric|min_value:0"
      v-slot="{ errors, classes }"
      slim
    >
      <b-form-group
        label-cols="12"
        label-cols-sm="7"
        label-for="alterationArea"
        class="mb-0">
        <template v-slot:label>
          <span class="req-ind">*</span>If the proposed land management road passes
          through a P-WL1 or P-WL2 wetland subdistrict, how much of these subdistricts
          will be altered* (in sq. ft.)? (43,560 sq. ft. = 1 acre)
        </template>
        <b-form-input
          type="number"
          id="alterationArea"
          name="alterationArea"
          v-model="roadDetails.alterationArea"
          placeholder="Enter Alteration Area"
          :class="classes"
          maxlength="7"
          :aria-describedby="$errorsIdString(errors, 'alterationArea')"
          :disabled="mfsAdmin"
        />
        <InputErrors :errors="errors" errorsIdPrefix="alterationArea" />
      </b-form-group>
      <b-row no-gutters>
        <b-col cols="12" sm="6" class="font-sm my-3 pl-sm-3">
          * 'Alteration' means dredging, bulldozing, removing or replacing soil, sand, vegetation,
          or draining or dewatering, filling, or any construction and/or repair of any permanent
          structure.
          <a
            href="https://www.maine.gov/dacf/lupc/laws_rules/ch10.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            See 10.27 LAND USE DISTRICTS &amp; STANDARDS
          </a>
        </b-col>
      </b-row>
    </ValidationProvider>
    <ValidationProvider
      v-if="roadDetails && requirements.roadDiscontinueDateRequired"
      name="Road Discontinue Date"
      :rules="{
        required: true,
        afterStartDate: notification.operationStartDate,
      }"
      v-slot="{ errors, classes }"
      slim
    >
      <b-form-group
        label-cols="12"
        label-cols-sm="7"
        label-for="discontinueDate">
        <template v-slot:label>
          <span class="req-ind">*</span>Indicate the date when proposed temporary land
          management roads will be discontinued:
        </template>
        <b-form-datepicker
          id="discontinueDate"
          name="discontinueDate"
          v-model="roadDetails.discontinueDate"
          :class="classes"
          ref="datepicker"
          placeholder="Choose a date"
          local="en"
          :aria-describedby="$errorsIdString(errors, 'discontinueDate')"
          :disabled="mfsAdmin"
        >
          <template #button-content>
            <FontAwesomeIcon icon="calendar-alt" aria-hidden="true" />
            <span class="sr-only">Choose a date</span>
          </template>
        </b-form-datepicker>
        <InputErrors
          :errors="errors"
          errorsIdPrefix="discontinueDate"
          class="d-block invalid-feedback"
        />
      </b-form-group>
    </ValidationProvider>
    <ValidationProvider
      v-if="roadDetails"
      name="FEMA Flood Zone"
      rules="required"
      v-slot="{ errors }"
      slim
    >
      <b-form-group
        label-cols="12"
        label-cols-sm="7"
        label-for="femaFloodZone">
        <template v-slot:label>
          <span class="req-ind">*</span>Will you be constructing a land management road through
          a National Flood Insurance FEMA flood zone in a community? (If unsure, check the
          community's FEMA flood map to determine whether the proposed construction falls within a
          mapped flood zone.  Copies of FEMA maps are available at LUPC regional offices and at
          <a href="https://msc.fema.gov" target="_blank" rel="noopener noreferrer">https://msc.fema.gov</a>)
        </template>
        <b-form-radio-group
          id="femaFloodZone"
          name="femaFloodZone"
          v-model="roadDetails.femaFloodZone"
          :aria-describedby="$errorsIdString(errors, 'femaFloodZone')"
          :disabled="mfsAdmin"
        >
          <b-form-radio class="noselect" :value="true">Yes</b-form-radio>
          <b-form-radio class="noselect" :value="false">No</b-form-radio>
        </b-form-radio-group>
        <InputErrors
          :errors="errors"
          errorsIdPrefix="femaFloodZone"
          class="d-block invalid-feedback text-right"
        />
      </b-form-group>
    </ValidationProvider>
  </b-form>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'RoadDetailsForm',
  props: {
    roadDetails: {
      type: Object,
      default() {
        return {
          alterationArea: null,
          discontinueDate: null,
          femaFloodZone: null,
        };
      },
    },
  },
  computed: {
    toDate() {
      const date = new Date(this.notification.operationStartDate);
      date.setHours(0, 0, 0, 0);
      date.setDate(date.getDate() - 1);
      return date;
    },
    ...mapState('Notification', {
      notification: state => state.notification,
    }),
    ...mapState('ActivityDetails', {
      requirements: state => state.requirements,
    }),
    ...mapGetters('ActivityDetails', ['roadPWLString']),
    ...mapGetters('User', ['mfsAdmin']),
  },
  mounted() {
    if (!this.roadDetails) { return; }
    if (!this.requirements.roadPWL1Exists && !this.requirements.roadPWL2Exists) {
      this.roadDetails.alterationArea = 0;
    }
  },
};
</script>
